package com.essntl.features.dashboard.ui.components.taskcard

import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Person
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import com.essntl.features.task.domain.model.TaskModel
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun OwnerTask(
    task: TaskModel,
) {
    Row {
        Icon(
            imageVector = Icons.Default.Person,
            contentDescription = "owner",
            tint = MaterialTheme.esColorScheme.iconPrimary,
            modifier = Modifier
                .size(20.dp),
        )

        Spacer(modifier = Modifier.width(1.spacing))

        Text(
            text = task.owner?.initials ?: "owner name!",
            style = MaterialTheme.esTypography.p2Medium14,
            overflow = TextOverflow.Ellipsis,
        )
    }
}